<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 15:57:34
 * @LastEditTime: 2021-07-15 11:31:59
 * @LastEditors: lsf
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\JobUnitQuery\ProjectPublicityStep.vue
 * @Description: 项目公示步骤条
 */
 -->

 <template>
  <div class="project-publicity-step">
    <div class="content-box">
      <div class="project-title">
        <div class="title-text">
          <span>{{projectTitle}}</span>
        </div>
        <div class="project-baseinfo-content">
          <div class="progress-cell">
            <span class="progress-title">建设单位:</span>
            <span class="progress-value">{{ detailData.jsdw }}</span>
          </div>
          <div class="progress-cell">
            <span class="progress-title">项目地点:</span>
            <span class="progress-value">{{ detailData.gcxxdd }}</span>
          </div>
          <div class="progress-cell">
            <span class="progress-title">测量事项:</span>
            <span class="progress-value">{{ detailData.wtsxs }}</span>
          </div>
          <div class="progress-cell">
            <span class="progress-title">测绘机构:</span>
            <span class="progress-value">{{ detailData.chdw }}</span>
          </div>
        </div>
      </div>

      <div class="project-progress-box">
        <van-steps direction="vertical" :active="active" active-color="#1D84FF">
          <van-step v-for="(item,index) in processData" :key="index">
            <div class="period-title-box">
              <div class="period-title" :class="{
                'period-style-0':index == 0,
                'period-style-1':index == 1,
                'period-style-2':index == 2,
                'period-style-3':index == 3,
                'period-style-4':index == 4,
              }">{{item.title}}</div>
              <div class="period-time">{{item.subTitle}}</div>
            </div>
            <div class="period-content-box" 
              :class="{
                'period-content-box-border-0':index == 0,
                'period-content-box-border-1':index == 1,
                'period-content-box-border-2':index == 2,
                'period-content-box-border-3':index == 3,
                'period-content-box-border-4':index == 4,
              }"
              v-if="item.desc.length > 0">
              <div class="period-content-item"  v-for="(child,childIndex) in item.desc" :key="childIndex">
                <span class="text-title">{{child.title}}:</span>
                <span class="text-content">{{child.data}}</span>
              </div>
            </div>
          </van-step>
        </van-steps>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import api from '@/utils/api/projectPublicity.api.js'
export default {
  name: 'ProjectPublicityStep',
  components: {
    NoData
  },
  props: {},
  data() {
    return {
      rid:"",//
      showSearch: false,
      showList: false,
      selected: 0,
      searchValue: '', // 搜索条件
      list: [],
      active:"",// 当前环节
      projectTitle: '',
      processData:[],// 过程数据
      baseInfo:{},// 
      detailData:{},// 列表详情
    }
  },
  watch: {
  },
  computed: {
    navTitle() {
      return "项目详情进度"
    }
  },
  methods: {
    //加载获取项目进度查询和办理列表
    loadData() {
      // this.loading = true
      let params = {}
      params.rid = this.rid
      params.isOuter = "1"
      return api.getProjectSchedule(params).then(res => {
        console.log('--res', res)
        this.projectTitle = res.data.title;
        this.processData = res.data.process;
        this.active = res.data.process.length - 1;
        // for(let i = 0; i < this.processData.length; i++){
        //   if(this.processData[i].subTitle == '尚未到达该环节'){
        //     if(i > 0){
        //       this.active = i - 1;
        //     }else{
        //       this.active = 0;
        //     }
        //   }
        // }
        return Promise.resolve(res)
      })
    },
  },
  created() {
  },
  mounted() {
    //判断是否有中间页
    this.detailData = this.$route.params.detailData;
    this.rid = this.detailData.rid;
    this.loadData()
  }
}
</script>
<style lang="scss" scoped>
.project-publicity-step {
  height: 100vh;
  width: 100%;
  .content-box {
    .project-title{
      font-weight: bold;
      color: #333333;
      min-height: 6vw;
      padding: 3vw 2vw;
      .title-text{
        text-align: center;
        padding: 2vw;
      }
      .project-baseinfo-content{
        .progress-cell {
          // display: flex;
          // align-items: center;
          min-height: 6vw;
          padding: 1vw 3vw;
          .progress-title {
            font-size: 14px;
            font-weight: 500;
            color: #666666;
            width: 20vw;
            text-align: left;
            padding: 5px 0px;
            &.title {
              font-weight: bold;
              color: #333333;
            }
          }
          .progress-value {
            flex: 1;
            font-size: 14px;
            font-weight: 500;
            border-radius: 1px;
            color: #333333;
            text-align: left;
            &.title {
              font-weight: bold;
              color: #333333;
            }
          }
        }
      }
    }
    .period-title-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 8vw;

      .period-title{
        font-size: 16px;
        font-weight: bold;
      }
      .period-style-0{
        font-size: 16px;
        font-weight: bold;
        color:#7A7A7A;
      }
      .period-style-1{
        font-size: 16px;
        font-weight: bold;
        color: #FCA4A4;
      }
      .period-style-2{
        font-size: 16px;
        font-weight: bold;
        color: #218CFF;
      }
      .period-style-3{
        font-size: 16px;
        font-weight: bold;
        color: #A15EC1;
      }
      .period-style-4{
        font-size: 16px;
        font-weight: bold;
        color: #36AC42;
      }
      .period-time{
        font-size: 14px;
        font-weight: 500;
        color: #333333;
      }
    }
    .period-content-box-border-0{
      border:1px solid #7A7A7A;
      background: rgba(#7A7A7A,0.2);
    }
    .period-content-box-border-1{
      border:1px solid #FCA4A4;
      background: rgba(#FCA4A4,0.2);

    }
    .period-content-box-border-2{
      border:1px solid #218CFF;
      background: rgba(#218CFF,0.2);
    }
    .period-content-box-border-3{
      border:1px solid #A15EC1;
      background: rgba(#A15EC1,0.2);
    }
    .period-content-box-border-4{
      border:1px solid #36AC42;
      background: rgba(#36AC42,0.2);
    }
    .period-content-box{
      border-radius: 5px;
      min-height: 5vw;
      padding: 3vw;
      .period-content-item{
        min-height: 6vw;
      }
      .text-title{
        font-size: 14px;
        font-weight: 500;
        color: #666666;
      }
      .text-content{
        color:#333333;
      }
    }
  }
}
</style>
